var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.76 14.64L12.8 11.68C13.76 10.48 14.4 8.88 14.4 7.2C14.4 3.2 11.2 0 7.2 0C3.2 0 0 3.2 0 7.2C0 11.2 3.2 14.4 7.2 14.4C8.88 14.4 10.48 13.84 11.68 12.8L14.64 15.76C14.8 15.92 15.04 16 15.2 16C15.36 16 15.6 15.92 15.76 15.76C16.08 15.44 16.08 14.96 15.76 14.64ZM1.6 7.2C1.6 4.08 4.08 1.6 7.2 1.6C10.32 1.6 12.8 4.08 12.8 7.2C12.8 10.32 10.32 12.8 7.2 12.8C4.08 12.8 1.6 10.32 1.6 7.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.470fb70f6c26c2a4643c9131b33db27d.svg";
export { ForwardRef as ReactComponent };